<template>
  <div class="etiquetas-proveedores-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :showOpcionInactivos="Boolean(false)"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Etiquetas de Proveedores">
          <b-table hover 
              responsive="sm"
              class="registro" 
              :busy="tableBusy"
              :items="etiquetasProveedores" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <!-- <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template> -->

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos de la Etiqueta</b-dropdown-item>
                <!-- <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Inactivar Motivo</b-dropdown-item> -->
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'etiquetasProveedores/getField',
  mutationType: 'etiquetasProveedores/updateField',
});

export default {
  name: 'EtiquetasProveedoresList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'etiquetasProveedores',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
    ]),
  },
  created() {
    this.getItems()
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('etiquetasProveedores/getEtiquetasProveedores')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'EtiquetaProveedorData', 
                          params: { id: item.id }});
    },
    editar (item) {
      this.$router.push({ name: 'EtiquetaProveedorEdit', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'EtiquetaProveedorAdd' });
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .etiquetas-proveedores-list .registro table td[aria-colindex="1"] {
    width: calc(100% - 30px);
  }
  .etiquetas-proveedores-list .registro table td[aria-colindex="2"] {
    width: 30px;
  }

</style>
